import { ProductData } from "./store/store";

export const getPrice = (priceData?: ProductData, currency?: string) => {
  return formatPrice(priceData?.UnitAmount, currency);
}

export const formatPrice = (v?: number, currency?: string) => {
  if (v === null || typeof v === "undefined") {
    return "--";
  }

  const price = v / 100;

  const formatter = new Intl.NumberFormat(currency === "brl" ? 'pt-BR' : 'en-US', {
    style: 'currency',
    currency,
    currencyDisplay: currency === "usd" ? "code" : "narrowSymbol",
  });

  return formatter.format(price);
}

const groupByCurrency = (m: Record<string, ProductData>, data: ProductData) => {
  m[data.Currency] = data;
  return m;
}

export const getProduct = (plan: string, products: ProductData[]) => {
  if (plan === "anual") {
    return products.filter(p =>
      p?.ProductName === "GoFarm® Plano Anual" ||
      (
        p?.ProductName?.includes("GoFarm") &&
        p?.ProductName?.includes("Anual")
      ))
      .reduce(groupByCurrency, {});
  }

  if (plan === "trimestral") {
    return products.filter(p =>
      p?.ProductName === "GoFarm® Plano Trimestral" ||
      (
        p?.ProductName?.includes("GoFarm") &&
        p?.ProductName?.includes("Trimestral")
      ))
      .reduce(groupByCurrency, {});
  }

  // if (plan === "diario") {
  //   return products.filter(p =>
  //     p?.ProductName === "GoFarm® Plano Diário" ||
  //     (
  //       p?.ProductName?.includes("GoFarm") &&
  //       p?.ProductName?.includes("Diário")
  //     ))
  //     .reduce(groupByCurrency, {});
  // }

  return null;
}

export type KeyPredicate = (key: string) => string;
export type ValuePredicate<T> = (value: T) => T;

export function mapEntries<V>(
  obj: { [k: string]: V },
  { keyFn, valueFn }: { keyFn?: KeyPredicate, valueFn?: ValuePredicate<V> },
): { [k: string]: V } {
  return Object.fromEntries(
    Object.entries(obj)
      .map(([k, v]) => [
        keyFn ? keyFn(k) : k,
        valueFn ? valueFn(v) : v,
      ])
  );
}